<template>
  <div>
    <div class="bg-white p-8">
      <!-- <img class="container" src="@/assets/image/banner2.png" alt /> -->
      <div>
        <Classify></Classify>
      </div>
    </div>
    <div class="mt-8">
      <List
        pagerBar
        flightBar
        sortBar
        :span="6"
        :data="data"
        v-slot="{ item }"
        @sorts="sorts"
        @reload="reload"
        @synsorts="reload"
        v-if="dataTotal"
        @handlePage="handlePage"
      >
        <Item :item="item"></Item>
      </List>
      <img src="@/assets/image/暂无数据.png" v-else class="m-auto" />
    </div>
  </div>
</template>
<script>
import { watchEffect, ref, reactive, computed } from "@vue/composition-api";
import List from "/src/components/base/list.vue";
import Item from "@/components/base/item.vue";
import Classify from "/src/components/product/classify.vue";
export default {
  components: { List, Classify, Item },
  setup(props, ctx) {
    const data = ref();
    const sorts = (value) => {
      reload(value);
    };
    const handlePage = (value) => {
      console.log(value);
      reload(value);
    };
    const dataTotal = computed(() => data.value?.total);
    const reload = (value) => {
      const query = {
        size: 36,
        orderby: value || ctx.root.$route.query.orderby || "-updated",
        q__pproduct__classify_id: ctx.root.$route.query.classify_id,
        q__name__icontains: ctx.root.$route.query.keyword,
        page: ctx.root.$route.query.page,
        color: ctx.root.$route.query.color,
        wh:ctx.root.$route.query.wh
      };

      if (Number(query.q__pproduct__classify_id) === 0) {
        Reflect.deleteProperty(query, "q__pproduct__classify_id");
      }

      ctx.root.$callapi("getProductList", query).then((d) => {
        data.value = reactive(d.data);
      });
    };
    watchEffect(() => {
      //
      reload();
    });

    return { data, sorts, reload, dataTotal, handlePage };
  },
};
</script>
<style scoped lang="scss"></style>
